import { useUnit } from "@/context/UnitContext";
import { Thermometer } from "lucide-react";

export default function TemperatureToggle({ variant = "default" }) {
  const { tempUnit, toggleTempUnit } = useUnit();
  const onDark = variant === "dark";
  return (
    <button
      data-testid="temp-unit-toggle"
      onClick={toggleTempUnit}
      aria-label={`Switch temperature unit to ${tempUnit === "F" ? "Celsius" : "Fahrenheit"}`}
      title={`Temperature: ${tempUnit === "F" ? "Fahrenheit" : "Celsius"}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-sm text-xs font-semibold transition-all duration-200 ${
        onDark ? "text-white/90 hover:bg-white/10" : "text-[#4B5950] hover:bg-[#EAF0EA] border border-[#DCE3DD]"
      }`}
    >
      <Thermometer className="h-4 w-4" />
      {tempUnit === "F" ? "°F" : "°C"}
    </button>
  );
}
